import { Timestamp } from "firebase/firestore";


class ModelCommon {
    static isNull = (text) => {
        return typeof text === "undefined" || text === null;
    }

    static toNumber = (text, isNotNull) => {
        if (this.isNull(text)) {
            return isNotNull ? 0 : null;
        }
        return Number(text);
    }

    static toText = (number, isNotNull) => {
        if (this.isNull(number)) {
            return isNotNull ? '' : null;
        }
        return String(number);
    }

    static toList = (value, isNotNull) => {
        if (this.isNull(value)) {
            return isNotNull ? [] : null;
        }
        return value;
    }

    static toMap = (value, isNotNull) => {
        if (this.isNull(value)) {
            return isNotNull ? {} : null;
        }
        return value;
    }

    static toSafeValue = (value) => {
        return this.isNull(value) ? null : value;
    }

    static toTimestamp = (value) => {
        if (this.isNull(value)) return null;

        // 이미 Timestamp 객체라면 그대로 리턴
        if (value instanceof Timestamp) {
            return value;
        }

        // 유사 객체이거나 from plain object로 왔을 경우
        if (value.seconds !== undefined && value.nanoseconds !== undefined) {
            return new Timestamp(value.seconds, value.nanoseconds);
        }

        // Date 객체일 경우
        if (value instanceof Date) {
            return Timestamp.fromDate(value);
        }

        return null;
    }
}


export default ModelCommon;